import { Navigate, NavLink, Outlet, useLocation } from "react-router-dom";
import { Building2, Inbox, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { Logo } from "@/components/Navbar";

const linkCls = ({ isActive }) =>
  `flex items-center gap-3 px-4 py-3 font-mono text-[11px] uppercase tracking-[0.2em] transition-colors duration-300 ${
    isActive ? "bg-brand text-white" : "text-stone-400 hover:bg-coal hover:text-stone-100"
  }`;

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="admin-loading">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-stone-500">Carregando...</p>
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" state={{ from: location }} replace />;

  return (
    <div className="flex min-h-screen bg-obsidian" data-testid="admin-layout">
      <aside className="hidden w-64 shrink-0 flex-col border-r border-white/10 bg-obsidian lg:flex">
        <div className="border-b border-white/10 px-6 py-5">
          <Logo />
          <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.3em] text-brand">Painel</p>
        </div>
        <nav className="flex flex-1 flex-col gap-1 p-3">
          <NavLink to="/admin/imoveis" data-testid="admin-nav-imoveis" className={linkCls}>
            <Building2 size={15} /> Imóveis
          </NavLink>
          <NavLink to="/admin/leads" data-testid="admin-nav-leads" className={linkCls}>
            <Inbox size={15} /> Leads
          </NavLink>
        </nav>
        <div className="border-t border-white/10 p-3">
          <a href="/" target="_blank" rel="noreferrer" data-testid="admin-view-site" className="flex items-center gap-3 px-4 py-3 font-mono text-[11px] uppercase tracking-[0.2em] text-stone-400 transition-colors hover:text-stone-100">
            <ExternalLink size={15} /> Ver site
          </a>
          <button onClick={logout} data-testid="admin-logout-button" className="flex w-full items-center gap-3 px-4 py-3 font-mono text-[11px] uppercase tracking-[0.2em] text-stone-400 transition-colors hover:text-brand">
            <LogOut size={15} /> Sair
          </button>
        </div>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex items-center justify-between border-b border-white/10 px-6 py-4 lg:hidden">
          <Logo />
          <div className="flex items-center gap-4">
            <NavLink to="/admin/imoveis" data-testid="admin-nav-imoveis-mobile" className={({ isActive }) => `font-mono text-[11px] uppercase tracking-[0.2em] ${isActive ? "text-brand" : "text-stone-400"}`}>Imóveis</NavLink>
            <NavLink to="/admin/leads" data-testid="admin-nav-leads-mobile" className={({ isActive }) => `font-mono text-[11px] uppercase tracking-[0.2em] ${isActive ? "text-brand" : "text-stone-400"}`}>Leads</NavLink>
            <button onClick={logout} aria-label="Sair" className="text-stone-400"><LogOut size={16} /></button>
          </div>
        </header>
        <main className="flex-1 px-6 py-8 lg:px-10 lg:py-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
